import _ from 'lodash';
import moment from 'moment';
import { SEARCH_DATE_FORMAT, DAYS_PARAM } from 'common/constants/constants';

const getFromStateSelector = (key, defaultValue) => state =>
  _.get(state, key, defaultValue);

export const getUiState = getFromStateSelector('uiState');

export const fill5IterationsIfNeeded = current5Iterations => {
  const createEmptyIteration = () => ({
    start_date: moment().year(0).month(0).date(1).format(SEARCH_DATE_FORMAT),
    end_date: moment().year(0).date(1).format(SEARCH_DATE_FORMAT),
    name: ''
  });

  const numOfIterationsToFill = 5 - current5Iterations.length;

  return [
    ...current5Iterations,
    ...new Array(numOfIterationsToFill).fill().map(createEmptyIteration)
  ];
};

export const iterationEndDate = endDate => {
  return moment
    .min(
      moment().startOf('day'),
      moment(endDate, SEARCH_DATE_FORMAT).startOf('day')
    )
    .format(SEARCH_DATE_FORMAT);
};

export const numOfDaysInIteration = (startDate, endDate) => {
  const end = moment(endDate).startOf('day');
  const start = moment(startDate).startOf('day');
  const diff = end.diff(start, DAYS_PARAM);

  // adding 1 to the diff value because moment.diff(DAYS_PARAM) is non-inclusive
  return diff <= 0 ? 1 : diff + 1;
};

//
export const isSelectedIterationByDates = ({
  uiStateDates,
  iterationStartDate,
  iterationEndDate
}) => {
  const { from, to } = uiStateDates;

  return iterationStartDate === from && iterationEndDate === to;
};
